export enum ConversationTemplateType {
    CONVERSATION_STARTER = 0,
    QUICK_ANSWER = 1,
}
